import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AppLayoutFacadeService} from "../app-layout-facade.service";
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {HorizonProfileToolbarComponent} from '../horizon-profile-toolbar/horizon-profile-toolbar.component';

@Component({
    selector: 'app-no-profile-available',
    templateUrl: './no-profile-available.component.html',
    styleUrls: ['./no-profile-available.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule, HorizonProfileToolbarComponent]
})
export class NoProfileAvailableComponent implements OnInit {

  email: string;
  
  constructor(private _appFacade: AppLayoutFacadeService) { }

  ngOnInit() {
    this.email = this._appFacade.email;
  }

  logout() {
    this._appFacade.logout();
  }
}
